import { connect } from "react-redux";

var SkillsetBanner = require("components/writing/questions/SkillsetBanner");
var AnswerWritingInterface = require("components/writing/answers/AnswerWritingInterface");
var BookRating = require("components/reading/books/BookRating");
var BookTextVariety = require("components/reading/books/BookTextVariety");

var Skillsets = require("lib/academic/Skillsets");
var CurrentUser = require("lib/account/CurrentUser");
var Spinner = require("components/utility/Spinner");
var Autosaver = require("components/writing/quizzes/Autosaver");

var ReadingActions = require("lib/actions/ReadingActions");
var ReadingSelectors = require("lib/selectors/ReadingSelectors");
var WritingActions = require("lib/actions/WritingActions");
var WritingSelectors = require("lib/selectors/WritingSelectors");

var StudentOnboardingModal = require("components/users/students/onboarding/StudentOnboardingModal");

var MyShelfRouting = require("lib/routing/MyShelfRouting");
var ZPDRange = require("lib/academic/ZPDRange");

require("writing/answers/new_answer_page.scss")

@connect(
	(state, props) => {
		var textID = $wr.getURLParameterByName("text_id");
		var answerID = $wr.getURLParameterByName("answer_id");
		var isReview = props.location.pathname == "/reviews/new";

		var book = ReadingSelectors.book({ state, id: textID })

		var downProps = { book };

		if (!(WritingSelectors.isLoadingQuestions({ state }) ||
			  WritingSelectors.isLoadingRatings({ state, key: "index" }) ||
			  WritingSelectors.isLoadingAnswers({ state, key: "index" }) ||
			  WritingSelectors.isLoadingAnswers({ state, key: "create" }))) {

			if (answerID) {
				var answer = WritingSelectors.answer({
					state, id: answerID
				});

			} else if (isReview) {
				var answer = WritingSelectors.reviews({
					state, filters: { text_id: textID }
				}).filter(x => x.draft || x.allow_revision)[0];

			} else {
				var answer = WritingSelectors.nonQuizAnswers({
					state, filters: { text_id: textID }
				}).filter(x => x.draft || x.allow_revision)[0];
			}

			if (answer) {
				downProps.draftAnswer = answer;
				downProps.question = WritingSelectors.question({ state, id: answer.question_id });
				downProps.draftRating = WritingSelectors.ratings({
					state, filters: { text_id: textID }
				})[0];

			} else if (!isReview) {
				if (downProps.book && downProps.book.text_variety) {
					downProps.questionOptions = WritingSelectors.mostRecentQuestions({
						state, count: QUESTION_OPTION_COUNT
					});
				}
			}
		}

		if (!CurrentUser.get().prefs.automatic_zpd_exclusion) {
			downProps.shouldExclude = false;
		} else if (!book) {
			downProps.shouldExclude = false;
		} else if (!book.lexile_score) {
			downProps.shouldExclude = true;
		} else {
			var zpdStatus = ZPDRange.getTextStatus(
				book.lexile_score, CurrentUser.get().current_reading_level
			);

			downProps.shouldExclude = zpdStatus == ZPDRange.UNDER;
		}

		return downProps;
	},
	(dispatch, props) => {
		var userID = CurrentUser.get().id
		var textID = $wr.getURLParameterByName("text_id");
		var isReview = props.location.pathname == "/reviews/new";

		// PopulateData Step A: Fetch the book so we can show the title and know the text variety
		function fetchBook() {
			dispatch(ReadingActions.fetchBookSynchronously({ id: textID, userID: userID })).then((response) => {
				var book = _.first(response.books);
				if (book) {
					fetchDraft(book.text_variety);
				} else {
					console.log("No book matching text ID found.")
				}
			});
		}

		// PopulateData Step B: Check to see if there is a draft answer or review
		function fetchDraft(textVariety) {
			if (isReview) {
				dispatch(WritingActions.fetchReviews({
					conditions: { textID, draftOnly: true },
					embeds: ["answer.question", "answer.meta_data", "answer.history"]
				})).then((response) => {
					if (_.isEmpty(response.answers) && textVariety) {
						fetchReviewQuestion(textVariety, null, true);
					}
				});
				dispatch(WritingActions.fetchRatings({ conditions: { textID } }));
			} else {
				dispatch(WritingActions.fetchNonQuizAnswers({
					conditions: { textID, draftOnly: true },
					embeds: ["answer.question", "answer.meta_data", "answer.history"]
				})).then((response) => {
					if (_.isEmpty(response.answers) && textVariety) {
						fetchAnswerQuestions(textVariety);
					}
				});
			}
		}

		// PopulateData Step C: If there wasn't a draft answer or review, fetch question options
		// 					 C.1: If this is review, we also need to create the answer record
		function fetchAnswerQuestions(textVariety) {
			var conditions = {
				textID: textID, sample: QUESTION_OPTION_COUNT
			}

			var filters = {
				allow_global_linked: true, 
				allow_generic: true,
				types: "generic-question,text-specific-question",
				text_varieties: textVariety,
				apply_scope: true
			}

			if (CurrentUser.get().prefs.prefer_teacher_practice_questions) {
				filters["prefer_user_id"] = true;
			}

			return dispatch(WritingActions.fetchQuestions({ filters, conditions }))
		}
		function fetchReviewQuestion(textVariety, excludeID, buildAnswer) {
			var conditions = { sample: 1 }

			var filters = {
				allow_global_linked: true, 
				allow_generic: true,
				types: REVIEW_QUESTION,
				text_varieties: textVariety,
				apply_scope: true
			}

			if (excludeID) {
				filters["exclude_ids"] = excludeID;
			}

			return dispatch(WritingActions.fetchQuestions({ filters, conditions })).then((response) => {
				// We need to create the new answer record for this review for the question
				if (buildAnswer) {
					var questionID = response.questions[0].id;
					if (!questionID) { console.error("No review question found"); return }
					return createNewAnswer(questionID, textVariety, REVIEW_ANSWER);
				} else {
					return response;
				}
			})
		}

		function createNewAnswer(questionID, textVariety, answerType) {
			var answerData = {
				text_id: textID, draft: true,
				text_variety: textVariety, question_id: questionID,
				answer_type: answerType
			};
			dispatch(ReadingActions.invalidateBookCache({}));
			return dispatch(WritingActions.createAnswer({ answer: answerData }));
		}

		return {
			populateData: fetchBook,
			changeQuestion: (isReview ? fetchReviewQuestion : fetchAnswerQuestions),
			createAnswer: createNewAnswer,
			fetchReviewQuestion: fetchReviewQuestion,
			fetchAnswerQuestions: fetchAnswerQuestions,

			deleteAnswer: (answerID) => {
				var update = {"activity:any:any": null};
				dispatch(ReadingActions.localUpdateBook({id: textID, update}));
				dispatch(ReadingActions.invalidateBookCache({}));
				return dispatch(WritingActions.deleteAnswer({ id: answerID }))
			},

			updateAnswer: (answerID, answerData) => {
				dispatch(ReadingActions.invalidateBookCache({}));
				return dispatch(WritingActions.updateAnswer({ id: answerID, update: answerData }))
			},

			createRating: (ratingData) =>
				dispatch(WritingActions.createRating({ rating: ratingData })),

			updateRating: (ratingID, ratingData) =>
				dispatch(WritingActions.updateRating({ id: ratingID, update: ratingData }))
	
		}
	}
)
class NewAnswerPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		LuckyOrangeClient.tagComponent("NewAnswerPage");
		this.state = this.initialStateData();
	}

	initialStateData() {
		return {
			autosaveLoading: false, questionChanged: false,
			loading: false, showConfirmDelete: false,

			// Answers only
			selectedQuestionID: null,

			// Reviews only
			tempRatingValue: null
		}
	}
	
	selectQuestions() {
		var book = this.props.book;
		var isReview = this.props.location.pathname == "/reviews/new";
		if (isReview) {
			if (_.isEmpty(book.answers) && book.text_variety) {
				this.props.fetchReviewQuestion(book.text_variety, null, true);
			}
		} else {
			if (_.isEmpty(book.answers) && book.text_variety) {
				this.props.fetchAnswerQuestions(book.text_variety);
			}
		}
	}

	textID() {
		if (this.props.book) {
			return this.props.book.text_id;
		} else {
			return $wr.getURLParameterByName("text_id");
		}
	}

	textVariety() {
		var textVariety = this.props.book.text_variety;
		if (!textVariety) {
			textVariety = "fiction"
		}
		return textVariety;
	}

	isReview() {
		return this.props.location.pathname == "/reviews/new";
	}

	onQuestionSelect(question, e) {
		this.buildNewAnswer(question.id);
	}

	answerType() {
		if (this.props.question && this.props.question.type === REVIEW_QUESTION) {
			return REVIEW_ANSWER
		} else {
			return PRACTICE_QUESTION_ANSWER
		}
	}

	buildNewAnswer(questionID) {
		this.props.createAnswer(questionID, this.textVariety(), this.answerType());
	}

	onAnswerComplete() {
		this.setState({ loading: true }, () => {
			this.saveAnswer(false).then(() => {
				LuckyOrangeClient.tagComponent("completed_answer");
				var awardText = this.isReview() ? "Great job on that review!" : "Great job on that answer!";
				var completedTask = this.isReview() ? "reviews" : "answers"

				this.setState({ autosaveLoading: false });
				window.wrNotifications.triggerDropDownNotification({
					title: "Done!", text: awardText, icon: "star" });
				CurrentUser.fetchCurrentUserCoinData();

				$wr.redirect(MyShelfRouting.getPath({
					activeView: MyShelfRouting.VIEWS.SHELF_VIEW,
					detailsView: completedTask,
					textID: this.props.book.text_id
				}));
			});
		});
	}

	autosaveDraft(callback) {
		this.setState({ autosaveLoading: true }, () => {
			this.saveAnswer(this.props.draftAnswer.draft).then(() => {
				this.setState({ autosaveLoading: false });
				if (callback) { callback(); }

			}).catch(() => {
				// Error Handling... allow future autosaving even if this one failed
				this.setState({ autosaveLoading: false });
				if (callback) { callback(); }				
			});
		});
	}

	saveAnswer(draftStatus) {
		var answer = this.props.draftAnswer;

		if (answer.sessionMetaData) {
			if (_.isEmpty(answer.meta_data)) {
				// First time saving the answer; Make a new meta data array
				var metaData = [answer.sessionMetaData];
			} else {
				var metaData = _.clone(answer.meta_data);
				if (_.last(metaData).session_start != answer.sessionMetaData.session_start)	{
					// First time saving the answer this session, but was loaded from draft
					// Push new meta data onto the array
					metaData.push(answer.sessionMetaData);
				} else {
					// Update this session's meta data
					metaData[metaData.length - 1] = answer.sessionMetaData;
				}
			}
		}
		
		var answerData = {
			draft: draftStatus,
			parts: (answer.localParts || answer.parts),
			meta_data: metaData,
			history: answer.history,
		};

		if (!answer.allow_revision) {
			answerData.excluded = this.props.shouldExclude;
		}

		if (!draftStatus) {
			answerData.autograder_data = answer.recentAutograderData;
			answerData.allow_revision = false;
		}

		if (this.props.questionChanged) {
			answerData.question_id = this.props.question.id;
		}

		return this.props.updateAnswer(answer.id, answerData)
	}

	getAutosaveHash() {
		var answer = this.props.draftAnswer;

		if (answer) {
			var hashString = _.pluck(answer.localParts, "text").join("|");
			hashString += "|" + this.props.question.body;
			hashString += "|" + JSON.stringify(answer.sessionMetaData);
			hashString += "|" + JSON.stringify(answer.recentAutograderData);

			var hashValue = $wr.hashCode(hashString);

			return hashValue;	
		}
	}

	showConfirmDelete() {
		if (confirm("If you delete this you will lose your work below. Are you sure?")) {
			this.deleteDraft(NewAnswerPage.BACKTOQUESTIONS);
		}
	}

	deleteDraft(changeQuestion) { 
		this.setState({ loading: true });
		this.props.deleteAnswer(this.props.draftAnswer.id).then(() => {
			this.setState({ loading: false });
			window.wrNotifications.triggerDropDownNotification({
				title: "Your work has been deleted!", text: "", icon: "trash" });

			if (changeQuestion == NewAnswerPage.BACKTOQUESTIONS) {
				this.setState(this.initialStateData(), this.componentDidMount);
			} else {
				$wr.redirect("/");
			}
		})
	}

	onRatingChange(newValue) {
		if (this.props.draftRating) {
			this.props.updateRating(this.props.draftRating.id, { value: newValue })

		} else if (!this.state.tempRatingValue) { // Prevents creating two
			this.setState({ tempRatingValue: newValue });

			this.props.createRating({
				value: newValue,
				value_cap: BookRating.DEFAULT_MAX_RATING,
				text_id: this.textID()
			});
		}
	}

	changeQuestions(e) {
		$wr.nope(e)
		this.props.changeQuestion(this.textVariety());
	}

	changeReviewQuestion() {
		this.props.changeQuestion(this.textVariety(), this.props.question.id).then((response) => {
			var newQuestion = response.questions[0];
			if (!newQuestion) { console.error("No more review questions!"); return }

			this.props.updateAnswer(this.props.draftAnswer.id, {
				question_id: newQuestion.id, parts: null, localParts: null,
				meta_data: null, sessionMetaData: null, recentAutograderData: null
			})
		});
	}

	renderChooseQuestion() {
		var title = "Choose Your Question";

		var skillsetPreviews = _.map(this.props.questionOptions, (question) => {
			return (
				<SkillsetBanner skillset={ question.skillset } key={ question.id }
					textVariety={ this.textVariety() }
					text={ question.body } small={ true }
					onClick={ this.onQuestionSelect.bind(this, question) } />
			);
		});

		var changeQuestionsLink = (
			<p className="changeQuestionsContainer">
				<a href="#" className="changeQuestionsLink"
					onClick={ this.changeQuestions }>Change Questions</a>
			</p>
		)

		return (
			<div>
				<header className="pageHeader">
					<h1>{ title }</h1>
				</header>
				<h3 className="textTitle onQuestionSelect">
					{ this.props.book.title }
				</h3>
				{ changeQuestionsLink }
				<div className="skillsetOptions">
					{ skillsetPreviews }
				</div>

			</div>
		);
	}

	renderWriteAnswer() {
		var skillset = this.isReview() ? "review" : this.props.question.skillset;

		if (this.isReview()) { 
			if (this.props.draftRating) {
				var ratingValue = this.props.draftRating.value;
			} else {
				ratingValue = this.state.tempRatingValue;
			}
			var bookRating = (
				<div className="reviewRating">
					How many stars would you give the book?{ " " }
					<BookRating editable={ true } currentRating={ ratingValue }
						onChange={ this.onRatingChange } />
				</div>
			);
			if (!this.state.loading) {
				var changeQuestionF = this.changeReviewQuestion;
			}
		} else {
			var backtoQuestionsContent = (
				<a href="#" key="confirm" onClick={ this.showConfirmDelete }>
					Back to Questions
				</a>
			)
		}

		return (
			<div>
				<SkillsetBanner skillset={ skillset } textVariety={ this.textVariety() } />
				
				<div className="backToQuestionsContainer">
					{ backtoQuestionsContent }
				</div>

				<h3 className="textTitle">
					{ this.props.book.title }
				</h3>

				<Autosaver onDeleteClick={ this.deleteDraft } textID={ this.textID() }
					autosaveLoading={ this.state.loading || this.state.autosaveLoading }
					getAutosaveHash={ this.getAutosaveHash } onAutosave={ this.autosaveDraft } />

				<AnswerWritingInterface topOuterChild={ bookRating }
					loading={ this.state.loading }
					answerID={ this.props.draftAnswer.id }
					onComplete={ this.onAnswerComplete }
					onQuestionChange={ changeQuestionF }
					questionIndex="solo" />

			</div>
		);
	}

	render() {
		if (this.state.loading || !this.props.book) {
			var pageContent = (
				<div><Spinner placeholder={ true } scale={ 1.7 } /></div>
			);

		} else if (!this.props.book.text_variety) {
			var pageContent = (
				<div className="textVariety">
					<header className="pageHeader">
						<h1>Select a Book Type</h1>
					</header>
					<h3 className="textTitle">
						{ this.props.book.title }
					</h3>
					<BookTextVariety book={ this.props.book } onSelect={ this.selectQuestions } />	
				</div>
			)
		} else if (this.props.question && this.props.draftAnswer) {
			var pageContent = this.renderWriteAnswer();
		} else if (this.props.questionOptions) {
			var pageContent = this.renderChooseQuestion();
		} else {
			var pageContent = (
				<div><Spinner placeholder={ true } scale={ 1.7 } /></div>
			);
		}

		var triggerOnboarding = ($wr.getURLParameterByName("first") == "true");
		if (triggerOnboarding) {
			var redirectPath = this.props.location.pathname + "?text_id=" + this.textID();
			var studentOnboardingModal = <StudentOnboardingModal writingTriggered={ true }
				redirectPath={ redirectPath } />;
		}

		return (
			<div className="container newAnswerPage">
				{ pageContent }
				{ studentOnboardingModal }
			</div>
		);
	}

	componentDidMount() {
		if (this.textID() != undefined) {
			this.props.populateData();
		}
	}

};

var REVIEW_QUESTION = 'review-question'
var REVIEW_ANSWER = 'review-answer'
var PRACTICE_QUESTION_ANSWER = 'practice-question-answer'

NewAnswerPage.WrappedComponent.propTypes = PageStrictPropTypes({
	// Data from @connect
	book: PropTypes.object,
	question: PropTypes.object,
	draftRating: PropTypes.object,
	draftAnswer: PropTypes.object,
	questionOptions: PropTypes.array,
	isLoadingDraft: PropTypes.bool,
	shouldExclude: PropTypes.bool,
	onSelect: PropTypes.func,

	// Action hooks from @connect
	populateData: PropTypes.func.isRequired,
	changeQuestion: PropTypes.func,
	createAnswer: PropTypes.func,
	deleteAnswer: PropTypes.func,
	updateAnswer: PropTypes.func,
	createRating: PropTypes.func,
	updateRating: PropTypes.func,
	fetchReviewQuestion: PropTypes.func,
	fetchAnswerQuestions: PropTypes.func

});

NewAnswerPage.BACKTOQUESTIONS = "backToQuestions"

var QUESTION_OPTION_COUNT = 4;

module.exports = NewAnswerPage;



// WEBPACK FOOTER //
// ./modules/components/writing/answers/NewAnswerPage.js